// Account Receivable Payments Vuex

import state from './receivablePaymentStates.js'
import * as getters from './receivablePaymentGetters.js'
import * as mutations from './receivablePaymentMutations.js'
import * as actions from './receivablePaymentActions.js'

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
